import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectCoopLevel } from "../../selectors/selectCoopInfo";
import { selectBuildingCount } from "../../selectors/selectExistingBuildingInfo";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { BuildingMaxed } from "../player-base/buildings/BuildingMaxed";
import { actionStoreBuyPackage } from "./actionStore";
import { StoreItemBuildingPurchase } from "./StoreItemBuildingPurchase";
import { StoreItemChestPurchase } from "./StoreItemChestPurchase";
import { StoreItemInformation } from "./StoreItemInformation";
import { StoreItemResourcePurchase } from "./StoreItemResourcePurchase";
import { StoreItemTitle } from "./StoreItemTitle";
var _DetailViewStoreItems = function (_a) {
    var coopLevel = _a.coopLevel, item = _a.item, onBuyPackage = _a.onBuyPackage, openInfoMenu = _a.openInfoMenu, maxBuildingAmountReached = _a.maxBuildingAmountReached;
    if (!item || !onBuyPackage || !openInfoMenu) {
        return React.createElement(React.Fragment, null);
    }
    var selectedItemIsBuilding = item.buildingRewardInfo !== undefined;
    var selectedItemIsPurchaseResource = item.purchasedResourceInfo !== undefined;
    var selectedItemIsChest = item.randomPoolRewardInfo !== undefined;
    var reward = React.createElement(React.Fragment, null);
    if (selectedItemIsBuilding) {
        reward = maxBuildingAmountReached ? (React.createElement(BuildingMaxed, null)) : (React.createElement(StoreItemBuildingPurchase, { item: item, onBuyPackage: onBuyPackage }));
    }
    else if (selectedItemIsPurchaseResource) {
        var isLocked = item.balancing.requCoopLevel !== undefined && item.balancing.requCoopLevel > coopLevel;
        reward = (React.createElement(StoreItemResourcePurchase, { item: item, onBuyPackage: onBuyPackage, isLocked: isLocked }));
    }
    else if (selectedItemIsChest) {
        reward = React.createElement(StoreItemChestPurchase, { item: item, onBuyPackage: onBuyPackage });
    }
    return (React.createElement("div", { className: "flex flex--guts " + IdStyles.DetailViewWrapper },
        React.createElement("div", { className: "store-menu-detail " + IdStyles.DetailView },
            React.createElement(StoreItemTitle, { item: item }),
            React.createElement(StoreItemInformation, { item: item, onInfoClick: openInfoMenu }),
            reward)));
};
var mapState = function (state, ownProps) {
    var coopLevel = selectCoopLevel(state);
    var item = ownProps.item;
    if (item && item.buildingRewardInfo) {
        var buildingCount = selectBuildingCount(state, item.buildingRewardInfo.id);
        var maxAmount = item.buildingRewardInfo.maxAmount;
        return {
            coopLevel: coopLevel,
            maxBuildingAmountReached: buildingCount >= maxAmount,
        };
    }
    return {
        coopLevel: coopLevel,
    };
};
var mapDispatch = function (dispatch, ownProps) {
    var item = ownProps.item;
    if (item) {
        var _a = item.balancing, id_1 = _a.id, cost_1 = _a.cost, randomPoolRewardInfo = item.randomPoolRewardInfo;
        var onInfoClick = randomPoolRewardInfo != undefined
            ? function () { return dispatch(actionModalOpen(IdModal.ShowAllRewardsStore)); }
            : function () { return dispatch(actionModalOpen(IdModal.BuildingInfo)); };
        return {
            onBuyPackage: function (sliderAmount) {
                var actualCost = (cost_1 || []).map(function (_a) {
                    var amount = _a.amount, resourceId = _a.resourceId;
                    return ({
                        amount: Long.fromNumber(amount).multiply(sliderAmount),
                        typeId: resourceId,
                    });
                });
                return dispatch(actionStoreBuyPackage(id_1, sliderAmount, actualCost));
            },
            openInfoMenu: onInfoClick,
        };
    }
    return {};
};
export var DetailViewStoreItems = connect(mapState, mapDispatch)(_DetailViewStoreItems);



//////////////////
// WEBPACK FOOTER
// ./src/features/store/DetailViewStoreItems.tsx
// module id = 2757
// module chunks = 3